import { browserHistory } from 'react-router';
import { getOrderDetailsUrl } from '../selectors';
import { ThunkResult } from '../../../stores/types';

const redirectToOrderDetails = (): ThunkResult<void> => (_dispatch, getState): void => (
  browserHistory.push(getOrderDetailsUrl(getState()) || ''));

export default redirectToOrderDetails;
